import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Search, Play, FileText } from "lucide-react";

const CATEGORIES = ["All","Newborn","Feeding","Wet diapers","Stool","Sleep","Growth","Vaccines","Fever","Nutrition","Eye care","Gas/colic","Parenting confidence"];

export default function Content() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("All");
  const [selected, setSelected] = useState(null);

  const load = async () => {
    const params = {};
    if (cat !== "All") params.category = cat;
    if (q) params.q = q;
    const { data } = await api.get("/content", { params });
    setItems(data);
  };

  useEffect(() => { load(); }, [cat]);

  return (
    <div className="max-w-7xl mx-auto px-4 py-8" data-testid="content-page">
      <div className="overline mb-1">Content Hub</div>
      <h1 className="font-display font-black text-3xl sm:text-4xl mb-2" style={{color:"#232F2F"}}>Reels, videos & articles</h1>
      <p className="text-[#5A6D6D] mb-6">Bite-sized parenting education by Dr. Hariom.</p>

      <div className="flex flex-col sm:flex-row gap-3 mb-6">
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5A6D6D]" size={16}/>
          <input value={q} onChange={(e)=>setQ(e.target.value)} onKeyDown={(e)=>e.key==="Enter"&&load()} placeholder="Search parenting tips..." className="w-full pl-9 pr-3 py-2.5 rounded-full border border-[#E5EBEB] bg-white" data-testid="content-search"/>
        </div>
        <div className="flex gap-2 overflow-x-auto pb-1">
          {CATEGORIES.map((c) => (
            <button key={c} onClick={()=>setCat(c)} className={`whitespace-nowrap px-3 py-1.5 rounded-full text-xs font-semibold ${cat===c?'bg-[#2D7A78] text-white':'bg-white border border-[#E5EBEB] text-[#5A6D6D]'}`} data-testid={`cat-${c}`}>{c}</button>
          ))}
        </div>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((it) => (
          <button key={it.id} onClick={()=>setSelected(it)} className="card-soft text-left" data-testid={`content-${it.id}`}>
            <div className="aspect-video rounded-xl mb-3 bg-gradient-to-br from-[#CBE4E8] to-[#FFD6C2] flex items-center justify-center">
              {it.kind === "reel" || it.kind === "video" ? <Play size={40} color="#2D7A78"/> : <FileText size={40} color="#2D7A78"/>}
            </div>
            <div className="flex items-center gap-2 mb-2">
              <span className="chip">{it.category}</span>
              <span className="chip chip-peach">{it.kind}</span>
            </div>
            <div className="font-display font-bold">{it.title}</div>
            <div className="text-sm text-[#5A6D6D] mt-1 line-clamp-2">{it.summary}</div>
            {it.reading_time && <div className="text-xs text-[#5A6D6D] mt-2">{it.reading_time} min read</div>}
          </button>
        ))}
      </div>
      {items.length === 0 && <div className="text-center py-12 text-[#5A6D6D]">No content found. Try a different filter.</div>}

      {selected && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={()=>setSelected(null)} data-testid="content-modal">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[85vh] overflow-y-auto p-6" onClick={(e)=>e.stopPropagation()}>
            <div className="flex items-center gap-2 mb-2">
              <span className="chip">{selected.category}</span><span className="chip chip-peach">{selected.kind}</span>
            </div>
            <h3 className="font-display font-black text-2xl mb-3">{selected.title}</h3>
            {selected.youtube_url && <div className="aspect-video mb-4"><iframe className="w-full h-full rounded-xl" src={selected.youtube_url} title={selected.title} allowFullScreen/></div>}
            <div className="text-sm whitespace-pre-wrap leading-relaxed text-[#232F2F]">{selected.body}</div>
            <div className="mt-6 flex flex-wrap gap-2">
              <a href="/book" className="btn-primary text-sm">Book Consultation</a>
              <button onClick={()=>setSelected(null)} className="btn-outline text-sm">Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
